<div class="w-full px-64 py-24 m-2 flex flex-col items-center gap-0">
  <i class="{{ informativeStatus?.iconProps?.icon }} | mergeClasses: {{ informativeStatus?.iconProps?.class }}"></i>
  <h1 class="text-3xl font-bold text-center">{{ (informativeStatus?.title || '') | translate }}</h1>
  <p *ngIf="informativeStatus?.subtitle" class="text-lg text-center">{{ (informativeStatus?.subtitle || '') | translate }}</p>
  <div class="flex flex-row">
    <p-button
      *ngIf="informativeStatus?.actionButton"
      label="{{ (informativeStatus?.actionButton?.label || '') | translate }}"
      (onClick)="informativeStatus?.actionButton?.onClick()"
      [styleClass]="'px-16 py-5'"></p-button>
  </div>
</div>
